import Grid from '@material-ui/core/Grid';

import ReportCard from '../form'
import ReportCardV2 from '../formV2'
import ValidationModal from '../form/validation-modal/index'

export default function StandardReportStep2({
	rowData,
	list,
	currentFilledFormIndex,
	// Standard Report Answers
	fixedGeneralAnswers,
	fixedInfoAnswers,
	fixedSoundAnswers,
	mobileGeneralAnswers,
	mobileInfoAnswers,
	mobileSoundAnswers,
	// Validation
	currentSelectedError,
	openValidationModal,
	onOpenValidationModal,
	onCloseValidationModal,
	// Document Status ID
	documentStatusID,
	// version
	reportVersion,
	flags,
}) {
	return (
		<>
			<Grid className="w-full flex flex-col gap-y-6">
				{reportVersion === '2' || reportVersion == 2 ? (
					<ReportCardV2
						quarter={rowData?.quarter}
						type={list[currentFilledFormIndex]}
						// Standard Report Answers
						fixedGeneralAnswers={fixedGeneralAnswers}
						fixedInfoAnswers={fixedInfoAnswers}
						fixedSoundAnswers={fixedSoundAnswers}
						mobileGeneralAnswers={mobileGeneralAnswers}
						mobileInfoAnswers={mobileInfoAnswers}
						mobileSoundAnswers={mobileSoundAnswers}
						// Validation
						currentSelectedError={currentSelectedError}
						openValidationModal={openValidationModal}
						onOpenValidationModal={onOpenValidationModal}
						onCloseValidationModal={onCloseValidationModal}
						// Document Status ID
						documentStatusID={documentStatusID}
						flags={flags}
					/>
				) : (
					<ReportCard
						quarter={rowData?.quarter}
						type={list[currentFilledFormIndex]}
						// Standard Report Answers
						fixedGeneralAnswers={fixedGeneralAnswers}
						fixedInfoAnswers={fixedInfoAnswers}
						fixedSoundAnswers={fixedSoundAnswers}
						mobileGeneralAnswers={mobileGeneralAnswers}
						mobileInfoAnswers={mobileInfoAnswers}
						mobileSoundAnswers={mobileSoundAnswers}
						// Validation
						currentSelectedError={currentSelectedError}
						openValidationModal={openValidationModal}
						onOpenValidationModal={onOpenValidationModal}
						onCloseValidationModal={onCloseValidationModal}
						// Document Status ID
						documentStatusID={documentStatusID}
					/>
				)
				}
			</Grid>
			<ValidationModal />
		</>
	)
}
